import React from 'react';
import {RenderOrEmpty} from '../index';

type RenderDivOrEmptyProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode,
  isShow: boolean,
}

function RenderDivOrEmpty(props: RenderDivOrEmptyProps) {
  const {isShow, ...divProps} = props;
  return (
    <RenderOrEmpty isShow={props.isShow}>
      <div {...divProps}>
        {props.children}
      </div>
    </RenderOrEmpty>
  );
}

export default RenderDivOrEmpty;
